import React from "react"
import { Link as GatsbyLink } from "gatsby"

const Link = ({ children, to, activeClassName, partiallyActive, className = '', ...other }) => {
  const internal = /^\/(?!\/)/.test(to)

  return internal ? (
    <GatsbyLink
      to={to}
      activeClassName={activeClassName}
      partiallyActive={partiallyActive}
      className={`${className}`}
      {...other}
    >
      {children}
    </GatsbyLink>
  ) : (
    <a href={to} className={`${className} u-underline`} {...other}>
      {children}
    </a>
  )
}

export default Link
